import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DataState {
    data: any[];
    isLoading: boolean;
    error: string;
    selectedData: any;
}

const initialState: DataState = {
    data: [],
    isLoading: false,
    error: '',
    selectedData: null,
};

const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setDataValue: <T extends keyof DataState>(state: DataState, action: PayloadAction<{ key: T, value: DataState[T] }>) => {
            const { key, value } = action.payload;
            state[key] = value;
        }
    }
});

export const { setDataValue } = dataSlice.actions;

export default dataSlice.reducer;
